<template>
    <div>
        <div v-if="checkConditions">

            <va-page-header>
                <div slot="title">
                    <va-button v-if="!$route.meta.isPublicView" class="back_button" @click.native="$router.go(-1)"
                        type="default" size="lg">
                        <va-icon type="chevron-left"></va-icon>
                    </va-button>

                    {{ g_getLabel(viewedForm) }}<span v-if="$route.meta.isPublicView == false"
                        class='status'>{{ _(viewedForm.get('status')) }}</span>
                </div>
                <div slot="actions" v-if="!$route.meta.isPublicView">
                    <div>
                        <va-button
                            v-if="(user.get('roles').includes('admin') || user.get('roles').includes('manager') || (userIsSubmitter && (user.get('roles').includes('survey-editor') || user.get('roles').includes('submitter')))) && viewedForm.get('status') == 'running'"
                            @click.native="navigate('/surveys/' + $route.params.scope + '/' + $route.params.category + '/' + viewedForm.get('class_name').slice(5) + '/data_submitter/new')"
                            type="primary" size="lg">
                            {{ _('NEW ENTRY') }}</va-button>
                    </div>
                </div>

            </va-page-header>

            <data-list :isSubmissions="true" />
        </div>
        <div v-else class="not_available">
            <span style="vertical-align: middle;">
                {{ _('Not available') }}
            </span>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";

    import DataList from "../DataList.vue"

    export default {

        components: {
            DataList
        },

        data() {
            return {
                viewedForm: { get: () => '' },
                myForm: null,

            };
        },
        computed: {
            ...mapGetters(['user']),


            checkConditions() {
                if ((this.$route.meta.isPublicView && this.viewedForm && this.viewedForm.get('is_submissions_public_available')) || this.user) {
                    return true;
                }
                return false;
            },

            userIsSubmitter() {
                var isSubmitter = false;
                if (this.myForm != null && this.myForm.get('survey_submitters') != null) {
                    for (let i = 0; i < this.myForm.get('survey_submitters').length; i++) {
                        const submitter = this.myForm.get('survey_submitters')[i];
                        if (submitter != null && this.user != null && submitter.id == this.user.id) {
                            isSubmitter = true;
                            break
                        }
                    }
                }
                return isSubmitter;
            }
        },
        watch: {
            async '$route'(v) {
                await this.fetchForm()
            }
        },
        methods: {
            navigate(to) {
                this.$router.push(to);
            },

            async fetchForm() {
                let q = new Parse.Query('Form')
                q.equalTo('class_name', 'Data_' + this.$route.params.form_slug)
                var res = this.viewedForm = await q.first()
                this.viewedForm = res
                this.myForm = res
            }
        },
        async mounted() {
            await this.fetchForm()
        }
    };
</script>

<style scoped>
    .submission_col_checkbox .va-checkbox-label {
        max-width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .deadCenter {
        width: 100%;
        bottom: 0;
        height: 100px;
        left: 0;
        margin: auto;
        position: relative;
        top: 0;
        right: 0;
        text-align: center;
    }

    .datatable td {
        overflow: hidden;
    }

    .smallPadding {
        padding: 4px 0px 4px 8px !important;
    }

    .mediumPadding {
        padding: 8px !important;
    }

    .largePadding {
        padding: 12px 8px !important;
    }


    .field_label {
        padding: 0px;
        max-width: 100px;
    }

    .field_chip {
        background: #333;
        color: white;
        border-radius: 3px;
        height: 28px;
        /* max-width: 100px; */
        display: flex;
        padding: 0px 4px;
    }

    .field_chip_exclude {
        background: #8e1c00;
        color: white;
        border-radius: 3px;
        height: 28px;
        /* max-width: 100px; */
        display: flex;
        padding: 0px 4px;
    }

    .chip-text {
        font-size: 0.8em;
        height: 17px;
        margin-top: 4px;
        /* max-width: 100px; */
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1 !important
    }


    .va-dropdown-con .va-dropdown-menu>div>li>a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        padding: 5px 12px;
        color: #172b4d;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.5;
    }

    .va-dropdown-con .va-dropdown-menu>div>li>a:hover {
        text-decoration: none;
        background-color: #f4f5f7;
    }

    .shortcut-btns {
        margin: 5px 5px 5px 0
    }

    .filter_question {
        font-weight: bold;
        font-size: 18px;
        padding: 10px 0px 10px 10px;
        color: #666;
    }

    .agent-email {
        width: 130px;
        position: absolute;
        top: 15%;
        font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .agent-name {
        position: absolute;
        top: 45%;
        color: gray;
        font-size: 12px;
        width: 130px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .exclude_checkbox {
        position: absolute !important;
        right: 11px;
        top: 18px;
    }

    .back_btn {
        /* background: red !important; */
        position: absolute;
        right: 22px;
        top: 35px;
    }

    .back_btn_toRight {
        position: absolute;
        right: 140px;
        top: 35px;
    }

    .showColDropDownLtr {
        zoom: 0.8;
        position: absolute;
        right: 24px;
        margin-top: 24px
    }

    .showColDropDownRtl {
        zoom: 0.8;
        position: absolute;
        left: 24px;
        margin-top: 24px
    }

    .labelRtl {
        position: absolute;
        font-size: 0.59em;
        background: #eee;
        line-height: 13px;
        padding: 0px 2px;
        font-weight: normal;
        top: 0;
        left: 0;
        font-family: verdana;
    }

    .labelLtr {
        position: absolute;
        font-size: 0.59em;
        background: #eee;
        line-height: 13px;
        padding: 0px 2px;
        font-weight: normal;
        top: 0;
        right: 0;
        font-family: verdana;
    }

    .entry_row {
        cursor: pointer;
        border-bottom: 1px solid #aaa3;
    }

    .approved_entry {
        position: absolute;
        font-size: 0.59em;
        background: #c9ffc1;
        line-height: 13px;
        padding: 0px 2px;
        font-weight: normal;
        top: 0;
        right: 0;
        font-family: verdana;
    }

    .rejected_entry {
        position: absolute;
        font-size: 0.59em;
        background: #ffd4d4;
        line-height: 13px;
        padding: 0px 2px;
        font-weight: normal;
        top: 0;
        right: 0;
        font-family: verdana;
    }
</style>